import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const moduleReadOnlyBannerNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.module_read_only_banner_drp, {
      displayName: 'Account takeover prevention',
      icon: SolIcon.asm_credentials,
      children: [
        SolNavbarItem.of(PrototypeRouteId.module_read_only_banner_exposed_accounts, {
          displayName: 'Exposed accounts',
        }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
